/**
 * One of the five body sections every analysis configuration dialog uses, in
 * this order: Inputs → Settings → Add-ons → Output → Advanced (spec
 * 2026-10-10-analysis-config-sections). A small uppercase heading over its
 * fields; consecutive sections are separated by a hairline.
 */
import { useId, type ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface AnalysisSectionProps {
  title: ReactNode;
  testId?: string;
  className?: string;
  children: ReactNode;
}

export function AnalysisSection({ title, testId, className, children }: AnalysisSectionProps) {
  const headingId = useId();
  return (
    <section
      data-testid={testId}
      aria-labelledby={headingId}
      className={cn(
        'flex min-w-0 flex-col gap-3 border-t border-slate-200/70 pt-4 first:border-t-0 first:pt-0 dark:border-stone-700/40',
        className,
      )}>
      <h3
        id={headingId}
        className='text-xs font-semibold tracking-wide text-slate-500 uppercase dark:text-stone-400'>
        {title}
      </h3>
      {children}
    </section>
  );
}
